const palette = [
  { color: 'blue-palette' },
  { color: 'green-palette' },
  { color: 'rose-palette' },
  { color: 'yellow-palette' },
];
const menuItems = [
  [
    {
      title: 'Home',
      img: 'home',
      router: '/',
      publicItem: true,
    },
    {
      title: 'Coins to Approve',
      img: '',
      router: '/allow-coins',
      enable: true,
      publicItem: false,
    },
    {
      title: 'Checklist',
      img: 'check_circle',
      router: '/checklist',
      enable: true,
      publicItem: true,
    },
    {
      title: 'Calendar',
      img: 'date_range',
      router: '/my-calendar',
      enable: true,
      publicItem: true,
    },
    {
      title: 'Student Tasks',
      img: 'assignment',
      router: '/tasks',
      enable: true,
      publicItem: true,
    },
    {
      title: 'Students Plans',
      img: 'grade',
      router: '/plan',
      enable: true,
      publicItem: true,
    },
    {
      title: 'Rewards',
      img: 'redeem',
      router: '/rewards',
      enable: true,
      publicItem: true,
    },
    {
      title: 'Progress',
      img: 'insights',
      router: '/progress',
      enable: true,
      publicItem: true,
    },
    {
      title: 'Leaderboard',
      img: 'emoji_events',
      router: '/ranking',
      enable: true,
      publicItem: true,
    },
    {
      title: 'Students Projects',
      img: 'folder_open',
      router: '/my-projects',
      enable: true,
      publicItem: true,
    },
    {
      title: 'Badges',
      img: 'new_releases',
      router: '/badges',
      enable: true,
      publicItem: true,
    },
  ],
  // Divider
  [
    {
      title: 'Learn skills',
      img: 'settings',
      router: '/learn-skills',
      enable: true,
      publicItem: true,
    },
    {
      title: 'Surveys',
      img: 'poll',
      router: '/surveys',
      enable: true,
      publicItem: false,
    },
    {
      title: 'FAQ',
      img: '',
      router: '/about',
      enable: true,
      publicItem: true,
    },
    {
      title: 'Tips',
      img: '',
      router: '/tips',
      enable: true,
      publicItem: true,
    },
  ],
  // Divider
  [
    {
      title: 'Change Student',
      img: 'people',
      router: '/childList',
      enable: true,
      publicItem: false,
    },
    {
      title: 'Coin Updater',
      img: 'bubble_chart',
      router: '/coins-updater',
      enable: true,
      publicItem: false,
    },
    {
      title: 'Activate Modules',
      img: 'check_circle',
      router: '/activate-modules',
      enable: true,
      publicItem: false,
    },
    {
      title: 'Manage Classes',
      img: 'class',
      router: '/manage-classes',
      enable: true,
      publicItem: false,
    },
    {
      title: 'Settings',
      img: '',
      router: '/settings',
      publicItem: true,
    },
    {
      title: 'Add Student',
      img: 'person_add',
      router: '/child-register',
      enable: true,
      publicItem: false,
    },
  ],
  // Divider
  [
    {
      title: 'Theme',
      img: '',
      router: null,
      palette: palette,
      publicItem: true,
    },
  ],
  // Divider
  [
    {
      title: 'Log out',
      img: '',
      router: '/logout',
      publicItem: true,
    },
  ],
];

const titleMappings = {
  'Student Tasks': 'My Tasks',
  'Students Plans': 'My Plans',
  'Students Projects': 'My Projects',
};

function getMenuItems(userIsParent) {
  const customizedMenu = JSON.parse(JSON.stringify(menuItems));

  if (userIsParent) {
    return customizedMenu;
  }

  customizedMenu.forEach((group) => {
    group.forEach((item) => {
      if (titleMappings[item.title]) {
        item.title = titleMappings[item.title];
      }
    });
  });

  return customizedMenu.map((itemsGroup) => itemsGroup.filter((item) => item.publicItem));
}

function getThemeColor(indexId) {
  return palette[indexId].color;
}

export { getMenuItems, getThemeColor };
